import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  headerTitleViewStyle: {
    flexDirection: 'row',
    overflow: 'hidden',
  },
  usageIconViewStyle: {
    alignSelf: 'flex-start',
    padding: 7,
    marginRight: 16,
  },
  deviceLableStyle: theme => ({
    fontSize: 16,
    lineHeight: 20,
    color: theme.colors.headerTitleColor,
    marginTop: 16,
  }),
  deviceNameStyle: theme => ({
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 28,
    lineHeight: 36,
    color: theme.colors.headerTitleColor,
  }),
  deviceInfoValue: theme => ({
    fontWeight: 'bold',
    fontSize: 20,
    lineHeight: 28,
    color: theme.colors.headerTitleColor,
  }),
});
